import React from "react";
import { Link } from "react-router-dom";
import { Phone, EnvelopeSimple, MapPin, ArrowRight } from "@phosphor-icons/react";
import { SITE, NAV } from "@/lib/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[var(--es-navy)] text-white">
      <div className="es-container py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3">
            <img src={SITE.logo} alt="Empire Serv" className="h-10 w-auto bg-white p-1 rounded-sm" />
            <div>
              <div className="font-bold tracking-tight text-lg" style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>EMPIRE SERV</div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-white/60">A Cleaner Environment</div>
            </div>
          </div>
          <p className="mt-5 text-sm text-white/70 leading-relaxed max-w-sm">
            A facilities maintenance partner trusted by medical, industrial, and government clients across the Carolinas and beyond.
          </p>
          <div className="mt-6 space-y-2.5 text-sm">
            <a href={SITE.phoneHref} data-testid="footer-phone-link" className="flex items-center gap-2 text-white/85 hover:text-white">
              <Phone size={16} weight="fill" className="text-[var(--es-accent)]" />{SITE.phone}
            </a>
            <a href={`mailto:${SITE.email}`} data-testid="footer-email-link" className="flex items-center gap-2 text-white/85 hover:text-white">
              <EnvelopeSimple size={16} weight="fill" className="text-[var(--es-accent)]" />{SITE.email}
            </a>
            <div className="flex items-start gap-2 text-white/85">
              <MapPin size={16} weight="fill" className="text-[var(--es-accent)] mt-0.5" />
              <span>{SITE.address.line1}<br />{SITE.address.city}, {SITE.address.state} {SITE.address.zip}</span>
            </div>
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.2em] font-semibold text-[var(--es-accent)] mb-4">Company</h4>
          <ul className="space-y-2 text-sm">
            {NAV.slice(0, 5).map(n => (
              <li key={n.to}><Link to={n.to} className="text-white/80 hover:text-white">{n.label}</Link></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.2em] font-semibold text-[var(--es-accent)] mb-4">Resources</h4>
          <ul className="space-y-2 text-sm">
            {NAV.slice(5).map(n => (
              <li key={n.to}><Link to={n.to} className="text-white/80 hover:text-white">{n.label}</Link></li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-xs uppercase tracking-[0.2em] font-semibold text-[var(--es-accent)] mb-4">Get Started</h4>
          <Link to="/quote" data-testid="footer-quote-cta" className="inline-flex items-center gap-2 text-sm font-semibold text-white border-b-2 border-[var(--es-accent)] pb-1 hover:gap-3 transition-all">
            Request a Quote <ArrowRight size={16} />
          </Link>
          <p className="mt-6 text-xs text-white/60 leading-relaxed">{SITE.hours}</p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="es-container py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-white/55">
          <div>© {new Date().getFullYear()} Empire Serv, Inc. All rights reserved.</div>
          <div className="flex items-center gap-4">
            <span>SAM.gov Registered</span>
            <span className="w-1 h-1 rounded-full bg-white/30" />
            <span>ISO 9001:2015 · CIMS-GB · GBAC STAR™</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
